<div class="student-points-bubble" [ngClass]="{'positive-bubble': points >= 0, 'negative-bubble': points < 0}">
  <span
    [ngClass]="{'points-positive': points >= 0, 'points-negative': points < 0}">
    {{totalPoints()}} pts
  </span>
</div>
